var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOther(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "#9F1239",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 12.5981V12.25C18.5 10.6825 16.1356 9.5 13 9.5C9.86438 9.5 7.5 10.6825 7.5 12.25V14.75C7.5 16.0556 9.14062 17.0931 11.5 17.4038V17.75C11.5 19.3175 13.8644 20.5 17 20.5C20.1356 20.5 22.5 19.3175 22.5 17.75V15.25C22.5 13.9563 20.9113 12.9175 18.5 12.5981ZM21.5 15.25C21.5 16.0763 19.5756 17 17 17C16.7669 17 16.5356 16.9919 16.3075 16.9769C17.6556 16.4856 18.5 15.6875 18.5 14.75V13.6087C20.3669 13.8869 21.5 14.6419 21.5 15.25ZM11.5 16.3906V14.9037C11.9974 14.9686 12.4984 15.0007 13 15C13.5016 15.0007 14.0026 14.9686 14.5 14.9037V16.3906C14.0034 16.464 13.502 16.5005 13 16.5C12.498 16.5005 11.9966 16.464 11.5 16.3906ZM17.5 13.8706V14.75C17.5 15.2744 16.7244 15.8375 15.5 16.1794V14.7188C16.3069 14.5231 16.99 14.2319 17.5 13.8706ZM13 10.5C15.5756 10.5 17.5 11.4237 17.5 12.25C17.5 13.0763 15.5756 14 13 14C10.4244 14 8.5 13.0763 8.5 12.25C8.5 11.4237 10.4244 10.5 13 10.5ZM8.5 14.75V13.8706C9.01 14.2319 9.69313 14.5231 10.5 14.7188V16.1794C9.27562 15.8375 8.5 15.2744 8.5 14.75ZM12.5 17.75V17.4894C12.6644 17.4956 12.8306 17.5 13 17.5C13.2425 17.5 13.4794 17.4919 13.7119 17.4781C13.9702 17.5706 14.2333 17.649 14.5 17.7131V19.1794C13.2756 18.8375 12.5 18.2744 12.5 17.75ZM15.5 19.3906V17.9C15.9972 17.9668 16.4983 18.0002 17 18C17.5016 18.0007 18.0026 17.9686 18.5 17.9038V19.3906C17.5053 19.5365 16.4947 19.5365 15.5 19.3906ZM19.5 19.1794V17.7188C20.3069 17.5231 20.99 17.2319 21.5 16.8706V17.75C21.5 18.2744 20.7244 18.8375 19.5 19.1794Z",
    fill: "#9F1239"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther);
export default __webpack_public_path__ + "static/media/Other.6e334dfabbabce4083192b5d2a504f17.svg";
export { ForwardRef as ReactComponent };